import TechnicalValidationProject from './TechnicalValidationProject.container';

export default TechnicalValidationProject;
